module.exports = __webpack_public_path__ + "img/05ed10b.jpg";